import * as emailValidator from '@rategravity/core-lib/validate-email';
import React from 'react';
import SessionCard from '../../components/card/session-card';
import hubspot from '../../modules/hubspot';
import { BorrowerCard } from '../card-lenses';
import { ContactInfo, nameValidator } from '.';

const OutOfStateShortCard = ({ onSubmit, ...props }) => (
  <ContactInfo
    {...props}
    onSubmit={
      onSubmit &&
      (() => {
        hubspot.registerOutOfStateLead(props.model.get('email'), {
          name: props.model.get('name'),
          scenario: props.scenario,
          // eslint-disable-next-line @typescript-eslint/camelcase
          loan_state: props.questionnaireState
        });
        onSubmit();
      })
    }
    buttonType="end"
    title={
      'Unfortunately, we’re not serving your state just yet. Leave us your email and we’ll send you a note when that changes.'
    }
  />
);

export const OutOfStateContactInfo = SessionCard(
  BorrowerCard(
    OutOfStateShortCard,
    'OutOfStateContactInfo',
    {},
    ({ model }) =>
      nameValidator(model.get('name')) && emailValidator.validate(model.get('email') || '')
  )
);



// WEBPACK FOOTER //
// ./src/cards/contact-info-short/out-of-state.js